import $ from 'jquery'
import AlertView from './view/alert-view'
import Model from './model/alert'

class Alert {
    constructor () {
        this.AlertView = AlertView
        this.Model = Model
    }

    closeAll () {
        $('.alert__item').remove()
    }

    // message: "Sua mensagem foi enviada com sucesso.",
    // type: "alert-success",
    create (data) {
        return new AlertView({
            className: 'alert__item',
            tagName: 'div',
            model: new Model(data)
        })
    }
}

window.GPAbstractModules = window.GPAbstractModules || {}
window.GPAbstractModules.Alert = Alert
